import { apiClient } from './client';

/**
 * Starts the GETs an event page makes on first paint, in parallel, as soon as the route mounts.
 * Without it they run as a waterfall: /auth/me (the route guard), then the event (to pick legacy
 * vs v2), then the UI's own fetches. The real consumers reuse these through the shared-GET adapter, so the URLs
 * must match theirs exactly. The client-only ones are warmed only for a known client role:
 * admins land on the legacy dashboard, which doesn't load them, and GET /event-timelines/:id
 * creates the timeline when it doesn't exist yet.
 */
export function warmEventRequests(eventId: string, role: string | undefined): void {
  if (!(localStorage.getItem('accessToken') || localStorage.getItem('token'))) return;

  // /auth/me is shared by the route guard and useAuth
  const urls = ['/auth/me', `/events/${eventId}`, `/events/${eventId}/budget`, `/event-selections?event_id=${eventId}`];
  if (role === 'client') {
    urls.push('/locations?is_active=true', `/event-timelines/${eventId}`);
  }
  // Failures are reported by the real consumers
  for (const url of urls) apiClient.get(url, { warm: true }).catch(() => {});
}
